import React from 'react';
import { motion } from 'framer-motion';

export interface CardProps {
  children: React.ReactNode;
  className?: string;
  hover?: boolean;
  onClick?: () => void;
  padding?: 'none' | 'sm' | 'md' | 'lg';
}

const Card: React.FC<CardProps> = ({
  children,
  className = '',
  hover = false,
  onClick,
  padding = 'md',
}) => {
  const paddingClasses = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8',
  };

  const baseStyles = 'bg-white rounded-lg shadow-md border border-gray-200';
  const hoverStyles = hover || onClick ? 'cursor-pointer transition-all duration-200 hover:shadow-lg hover:border-gray-300' : '';
  const clickableStyles = onClick ? 'active:scale-[0.98]' : '';

  const Component = onClick ? motion.div : 'div';
  const motionProps = onClick
    ? {
        whileHover: { y: -2 },
        whileTap: { y: 0 },
        onClick,
      }
    : {};

  return (
    <Component
      className={`${baseStyles} ${hoverStyles} ${clickableStyles} ${paddingClasses[padding]} ${className}`}
      {...motionProps}
    >
      {children}
    </Component>
  );
};

export default Card;

